import { render, staticRenderFns } from "./errors.vue?vue&type=template&id=1ee621ee&scoped=true&"
import script from "./errors.vue?vue&type=script&lang=js&"
export * from "./errors.vue?vue&type=script&lang=js&"
import style0 from "./errors.vue?vue&type=style&index=0&id=1ee621ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee621ee",
  null
  
)

export default component.exports